import { useLayoutEffect } from 'react'
import { forceCheck } from 'react-lazyload'

/**
 *
 * A React Hook
 * @example   useForceCheckLazyLoaded();
 * @returns {null} - nothing as it just does lazy loading in screen view force check
 *
 */

function useForceCheckLazyLoaded() {
  useLayoutEffect(() => {
    setTimeout(() => {
      forceCheck()
    }, 1500)
    setTimeout(() => {
      forceCheck()
    }, 2100)
    setTimeout(() => {
      forceCheck()
    }, 2500)
    setTimeout(() => {
      forceCheck()
    }, 3000)
  }, [])

  return null
}

export default useForceCheckLazyLoaded
